import { render, staticRenderFns } from "./NewIssuerRequests.vue?vue&type=template&id=71e13c87"
import script from "./NewIssuerRequests.vue?vue&type=script&lang=js"
export * from "./NewIssuerRequests.vue?vue&type=script&lang=js"
import style0 from "./NewIssuerRequests.vue?vue&type=style&index=0&id=71e13c87&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports